import {UserLevel} from '@netx/core-user-next/constants';

export const UPLOAD_ASSET_REQUESTS_MANAGE_MINIMUM_USER_LEVEL =
	UserLevel.PRODUCER;

export enum UploadAssetRequestPref {
	ENABLED = 'asset.assetRequestEnabled',
}

export const UPLOAD_ASSET_REQUEST_PAGE_SIZE = 25;
